<template>
    <div>
        <div class="mainTitle text-center mt-4 mb-3">
            <h3 class="uppercase mb-4"> {{$t('cp_changePassword')}}</h3>
            <message-component :message="response_msg" :messageType="msg_type" v-if="response_msg != ''"></message-component>
        </div> 
        <!--loader - message--->
        <complete-loading :pageloader_value="pageLoader" :type="'complete'" v-if="pageLoader"></complete-loading>
        
        <div class="CustomBlockWidth ">  
            <div class=" row justify-content-center"> 
                <div class="middleBox inMiddle-area whiteBG p-4  ">    
                    <div class="form-group field-wrapper dob">
                        <input placeholder=" " :type="inputtype" v-model="old_password"   class="float-field form-control" v-validate="'required'"   :class="{ 'is-invalid': submitted && errors.has('old_password') }" ref="old_passwordInput" name="old_password"  />
                        <label for="password" class="float-label"> {{$t('cp_oldpwd')}}</label>
                        <feather :type="iconType" class="toggle-password" @click.prevent="switchVisibility('')"></feather>
                    </div>
                 
                    <div class="form-group field-wrapper dob">
                        <input placeholder=" " :type="inputtype1" v-model="new_password"   class="float-field form-control"  v-validate="{ required: true,regex: /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?!.*[\\\/])(?=.*[!@#$%^&*])\S{6,24}$/}"   :class="{ 'is-invalid': submitted && errors.has('new_password') }"    ref="new_passwordInput" name="new_password" />
                        <label for="password" class="float-label"> {{$t('cp_newPassword')}}</label>
                        <feather :type="iconType1" class="toggle-password" @click.prevent="switchVisibility('1')"></feather>
    					<p class="error" v-for="error in errors.collect('new_password')">
    						<span v-show="submitted && error == 'The new_password field is required.'">{{$t('reg_passwordFieldReq')}}</span>
    						<span v-show="submitted &&error == 'The new_password field format is invalid.'">{{$t('cp_passCharval')}}</span>
    					</p>
                    </div>
                
                    <div class="form-group field-wrapper dob">
                        <input placeholder=" " :type="inputtype2" v-model="confirm_password"  class="float-field form-control" v-validate="{ required: true,  regex: /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*/])\S{6,15}$/, confirmed:new_password}"  :class="{ 'is-invalid': submitted && errors.has('confirm_password') }" ref="confirm_passwordInput" name="confirm_password"  />
                        <label for="password" class="float-label"> {{$t('cp_conPassword')}}</label>
                        <feather :type="iconType2" class="toggle-password" @click.prevent="switchVisibility('2')"></feather>
    					<p class="error" v-for="error in errors.collect('confirm_password')">
    						<span v-show="submitted && error == 'The confirm_password field is required.'">{{$t('reg_ConfpasswordReq')}}</span>
    						<span v-show="submitted && error == 'The confirm_password field format is invalid.'">{{$t('cp_passCharval')}}</span>
    						<span v-show="submitted && error == 'The confirm_password confirmation does not match.'">{{$t('reg_newConfFieldSame')}}</span>
    					</p>
                    </div>
                 
                    <div class="submitButton d-flex justify-content-center align-items-center w-100 mt-2 text-center">
                        <button class="prism_btn" v-on:click.stop.prevent="changePassword()">{{$t('cp_changePassword')}}</button>
                    </div> 
                </div>
            </div> 
        </div> 
    </div>
</template>
<script>
    import { fxViewMixins } from '@/plugins/fxView'
    import { mapActions } from 'vuex'
    import * as types from '@/types'
    export default {
        name: 'Deposit',
        mixins: [fxViewMixins],
        data() {
            return {
                pageLoader : false,
                response_msg : '',
                msg_type : '',
                old_password : '',
                new_password : '',
                confirm_password : '',
                submitted : false,

                inputtype : 'password',
                inputtype1 : 'password',
                inputtype2 : 'password',
                iconType : 'eye-off',
                iconType1 : 'eye-off',
                iconType2 : 'eye-off',
                showpassword1 : false,
                showpassword2 : false,
                showpassword : false,
            }
        },
        methods:{
           ...mapActions({
                _runChangePassword: types.RUN_CHANGE_PASSWORD
            }),
           switchVisibility(getData) {
                if(getData == '1'){
                    this.showpassword1 = !this.showpassword1
                    if(this.showpassword1){
                        this.inputtype1 = 'text'
                        this.iconType1 = 'eye'
                    }else{
                        this.inputtype1 = 'password'
                        this.iconType1 = 'eye-off'
                    } 
                }else if(getData == '2'){
                    this.showpassword2 = !this.showpassword2
                    if(this.showpassword2){
                        this.inputtype2 = 'text'
                        this.iconType2 = 'eye'
                    }else{
                        this.inputtype2 = 'password'
                        this.iconType2 = 'eye-off'
                    } 
                }else{
                    this.showpassword = !this.showpassword
                    if(this.showpassword){
                        this.inputtype = 'text'
                        this.iconType = 'eye'
                    }else{
                        this.inputtype = 'password'
                        this.iconType = 'eye-off'
                    } 
                }
                
            },
            changePassword(){
                const _that = this
                _that.submitted = true;
                _that.$validator.validate().then(valid => {
                    if (valid) {
						let input_json={
							'globalParams' :{
								'oldpassword' : _that.old_password ,
								'password' : _that.new_password
							},
							'localParams' :{ "parameter" : _that }
						}
						_that._runChangePassword(input_json)
                    }else{
                        _that.handleValidationErrorAdvanced(_that.errors)
                    }
                });
            },
            clear(){
                this.old_password = ''
                this.new_password = ''
                this.confirm_password = ''
                this.submitted = false
                this.inputtype = 'password'
                this.inputtype1 = 'password'
                this.inputtype2 = 'password'
            }
           
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/fxView/users/change_password.vue